<label [attr.for]="nzFor" [class.ant-form-item-no-colon]="labelNoColon" [class.ant-form-item-required]="nzRequired">
  <ng-content></ng-content>
  <span *ngIf="nzTooltipTitle" class="ant-form-item-tooltip" ui-tooltip [uiTooltipTitle]="nzTooltipTitle">
    <ng-container *nzStringTemplateOutlet="tooltipIcon.type; let tooltipIconType">
      <ui-icon [uiTheme]="tooltipIcon.theme" [uiType]="tooltipIconType"></ui-icon>
    </ng-container>
  </span>
</label>
